// Application update manager
// Check if the application source js bundle URL (which includes a unique hash)
// has changed.
// This is done by fetching index.html, which is the only source file
// not cached by our cloudfront distribution.

export default {
  lastCheck: Date.now() - 301e3,  // check initially
  checkInterval: 300e3,  // 5 min
  checkForUpdate (callback) {
    if (Date.now() - this.lastCheck > this.checkInterval) {
      this.lastCheck = Date.now()
      let elems = document.querySelectorAll('script[src*="app"]')
      let currentAppSourceUrl = elems[elems.length - 1].getAttribute('src')
      fetch('/').then((response) => {
        if (response.status >= 200 && response.status < 300) {
          response.text().then((body) => {
            if (body.indexOf(currentAppSourceUrl) < 0) {
              // an update is available
              callback()
            }
          })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/update/index.js